import { useQuery } from '@tanstack/react-query';
import { fetchTenantMe } from '@/lib/auth/tenant-auth';
import { resolveTenantId } from '@/lib/auth/tenant-id';
import { queryKeys } from '@/lib/query/query-keys';
import { queryPolicies } from '@/lib/query/query-client';

export function useTenantMe() {
  const tenantId = resolveTenantId();

  return useQuery({
    queryKey: queryKeys.tenant.me(tenantId),
    queryFn: fetchTenantMe,
    enabled: Boolean(tenantId),
    ...queryPolicies.tenantConfig,
  });
}
